// extracted by mini-css-extract-plugin
module.exports = {"reminderType":"styles_reminderType__puSnL"};